// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"07852a43","845":"3663b4f0"}[chunkId] + ".chunk.js";
};